<div class="confirm-cont column-base div-center">
  <i-tabler
    name="alert-circle"
    class="icon-20"
    style="height: 88px; width: 88px; color: #fdc560"
  ></i-tabler>

  <h2 style="text-align: center" class="">
    ¿Estás seguro de eliminar este documento?
  </h2>

  <span class="warn">Esta acción no se puede deshacer.</span>
  <div class="div-center row-base" style="width: 100%; gap: 30px">
    <button
      (click)="removeEvidence()"
      class="buttonPrimary row-base div-center div-vertical-center white-spinner"
      style="gap: 4px; min-width: 95px; box-shadow: none; min-height: 36px"
      [style.cursor]="isRemovingEvidence ? 'not-allowed' : 'pointer'"
    >
      <mat-spinner *ngIf="isRemovingEvidence" [diameter]="16"></mat-spinner>

      <span *ngIf="!isRemovingEvidence">Si, eliminar</span>
    </button>
    <button
      mat-flat-button
      style="
        border: 1px solid #e95a1a;
        border-radius: 4px;
        width: 95px;
        color: #e95a1a;
      "
      (click)="onClose()"
      class="m-l-8"
    >
      Cancelar
    </button>
  </div>
</div>
